import React from 'react';
import { Modal } from 'react-bootstrap';
import CRNAProfileForm from '../CRNAProfileForm/CRNAProfileForm';

const EditableProfileModal = ({ show, handleClose }) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}   // covers both the “×” and backdrop clicks
      size="lg"
      centered
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit Your CRNA Profile</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {/* onComplete also triggers handleClose */}
        <CRNAProfileForm onComplete={handleClose} />
      </Modal.Body>
    </Modal>
  );
};

export default EditableProfileModal;
